import axios from 'axios';

const viewerAccessKey = sessionStorage.getItem('viewerAccessKey') + "=";

export class GaleriaServices {
    getValuesServiceSerie(servicoImagem, studyUid) {
        let seriesAslDicom = [];
        
        return axios.get(`${servicoImagem}/${studyUid}/getstudyimagens`, {
            headers: {
                'Authorization': `Basic ${viewerAccessKey}`
            }
        })
            .then(res => {
                res.data.instanceImage.forEach(obj => {
                    seriesAslDicom.push({
                        Serie: obj.serie,
                        Instances: obj.instances
                    });
                });
                return seriesAslDicom;
            })
            .catch(error => {
                console.log(error);
                return [];
            });
    }
}